export const baseUrl = process.env.REACT_APP_API_URL || "not-set";

const API_ROUTE_TAGS = {
  AUTH: "/auth",
  DATA: "/data",
  JOB: "/job",
  REPORT: "/report",
  FILE: "/file",
  VALIDATION: "/job/validation",
};

export const API_ROUTES = {
  AUTHENTICATE: `${API_ROUTE_TAGS.AUTH}/authenticate`,
  VALIDATE_MAGIC_LINK: `${API_ROUTE_TAGS.AUTH}/magic-link/validate`,
  CREATE_MAGIC_LINK: `${API_ROUTE_TAGS.AUTH}/magic-link/create`,
  RETRIEVE_USER_CONTEXT: `${API_ROUTE_TAGS.AUTH}/retrieve-user-context`,
  GET_CONTROL_PANEL_DATA: `${API_ROUTE_TAGS.DATA}/get-control-panel-data`,
  UPLOAD_PORTFOLIO: `${API_ROUTE_TAGS.FILE}/upload-portfolio`,
  UPLOAD_VOTING_RECORDS: `${API_ROUTE_TAGS.FILE}/upload-voting-records`,
  UPLOAD_ENGAGEMENT_RECORDS: `${API_ROUTE_TAGS.FILE}/upload-engagement-records`,
  CALCULATE_COMPASS_METRICS: `${API_ROUTE_TAGS.JOB}/run-calculate-compass-metrics-job`,
  PROCESS_VOTING_METRICS: `${API_ROUTE_TAGS.JOB}/run-process-voting-records-job`,
  PROCESS_ENGAGEMENT_METRICS: `${API_ROUTE_TAGS.JOB}/run-process-engagement-records-job`,
  GET_COMMON_DATA: `${API_ROUTE_TAGS.DATA}/get-common-data`,
  CREATE_REPORT: `${API_ROUTE_TAGS.REPORT}/start-standard-report-creation`,
  CHECK_REPORT_STATUS: `${API_ROUTE_TAGS.REPORT}/get-report-creation-status`,
  GET_SCREENER_DATA: `${API_ROUTE_TAGS.DATA}/get-screener-data`,
  GET_COMPANY_SUMMARY: `${API_ROUTE_TAGS.DATA}/get-company-data`,
  GET_VOTING_DATA: `${API_ROUTE_TAGS.DATA}/get-voting-data`,
  GET_VOTING_SUMMARY: `${API_ROUTE_TAGS.DATA}/get-voting-summary`,
  GET_COMPANIES_VOTING_SUMMARY: `${API_ROUTE_TAGS.DATA}/get-companies-voting-summary`,
  GET_VOTING_EXECUTION: `${API_ROUTE_TAGS.DATA}/get-voting-execution`,
  GET_VOTING_AGAINST_MANAGEMENT: `${API_ROUTE_TAGS.DATA}/get-voting-divergent`,
  GET_ENGAGEMENT_DATA: `${API_ROUTE_TAGS.DATA}/get-engagement-data`,
  GET_ENGAGEMENTS_BY_MANAGER: `${API_ROUTE_TAGS.DATA}/get-engagement-count-by-manager`,
  GET_ENGAGEMENTS_BY_THEME: `${API_ROUTE_TAGS.DATA}/get-engagement-count-by-theme`,
  GET_ENGAGEMENTS_BY_GEO: `${API_ROUTE_TAGS.DATA}/get-engagement-count-by-geo`,
  GET_STEWARDSHIP_SCREENER_DATA: `${API_ROUTE_TAGS.DATA}/get-engagement-screener-data`,
  GET_STEWARDSHIP_SCREENER_CONFIG: `${API_ROUTE_TAGS.DATA}/get-engagement-screener-config`,
  GET_ALL_MANAGERS: `${API_ROUTE_TAGS.DATA}/get-all-managers`,
  GET_TASKS: `${API_ROUTE_TAGS.DATA}/get-tasks`,
  CREATE_TASK: `${API_ROUTE_TAGS.DATA}/create-task`,
  DELETE_TASK: `${API_ROUTE_TAGS.DATA}/delete-task`,
  ADD_TASK_NOTE: `${API_ROUTE_TAGS.DATA}/add-task-note`,
  GET_NOTE: `${API_ROUTE_TAGS.DATA}/get-note`,
  GET_USERS: `${API_ROUTE_TAGS.DATA}/get-all-users`,
  GET_COMPANIES: `${API_ROUTE_TAGS.DATA}/get-companies`,
  GET_GLOBAL_SEARCH: `${API_ROUTE_TAGS.DATA}/get-global-search`,
  GET_TASK_TRAIL: `${API_ROUTE_TAGS.DATA}/get-task-trail`,
  GET_TASKS_SUBJECTS: `${API_ROUTE_TAGS.DATA}/get-task-subjects`,
  UPDATE_TASK: `${API_ROUTE_TAGS.DATA}/update-task`,
  CREATE_FLAG: `${API_ROUTE_TAGS.DATA}/create-flag`,
  UPDATE_FLAG: `${API_ROUTE_TAGS.DATA}/update-flag`,
  GET_PORTFOLIOS_TEMPERATURE: `${API_ROUTE_TAGS.DATA}/get-portfolios-temp`,
  GET_PORTFOLIOS_FOSSIL_FUEL_EXPOSURE: `${API_ROUTE_TAGS.DATA}/get-portfolios-fossil-fuel-exposure`,
  GET_TOP_CONTRIBUTORS: `${API_ROUTE_TAGS.DATA}/get-portfolios-top-contributors`,
  GET_COMPANY_NEWS: `${API_ROUTE_TAGS.DATA}/get-company-news`,
  GET_NEWS_SEARCHES: `${API_ROUTE_TAGS.DATA}/get-news-searches`,
  GET_COMPANY_PUBLIC_METRICS: `${API_ROUTE_TAGS.DATA}/get-company-public-metrics`,
  GET_ENGAGEMENT_SUBTHEME_METRICS: `${API_ROUTE_TAGS.DATA}/get-engagement-subtheme-metrics`,
  UPSERT_ENGAGEMENT_SUBTHEME_METRICS: `${API_ROUTE_TAGS.DATA}/upsert-engagement-subtheme-metrics`,
  UPSERT_ENGAGEMENT_RECORD: `${API_ROUTE_TAGS.DATA}/upsert-engagement-record`,
  GET_CUSTOM_TAGS: `${API_ROUTE_TAGS.DATA}/get-custom-tags`,
  GET_COMPANIES_ENGAGEMENT_MATERIALITY: `${API_ROUTE_TAGS.DATA}/get-companies-engagement-materiality`,
  GET_COMPANIES_ENGAGEMENT_TOPIC_MAPPING: `${API_ROUTE_TAGS.DATA}/get-companies-engagement-topic-mapping`,
  GET_ENGAGEMENT_RECORD_STATUSES: `${API_ROUTE_TAGS.DATA}/get-engagement-record-statuses`,
  GET_MANAGER_PROFILE: `${API_ROUTE_TAGS.DATA}/get-manager-profile`,
  GET_ENGAGEMENT_TIMELINE: `${API_ROUTE_TAGS.DATA}/get-engagement-timeline`,
  ADD_ENGAGEMENT_UPDATE: `${API_ROUTE_TAGS.DATA}/add-engagement-update`,
  DELETE_ENGAGEMENT_UPDATE: `${API_ROUTE_TAGS.DATA}/delete-engagement-update`,
  // Validation endpoints
  VALIDATE_ENGAGEMENTS: `${API_ROUTE_TAGS.VALIDATION}/engagements`,
  VALIDATE_VOTING: `${API_ROUTE_TAGS.VALIDATION}/voting`,
  VALIDATE_PORTFOLIO: `${API_ROUTE_TAGS.VALIDATION}/portfolio`,
  // File endpoints
  FILE_LIST: `${API_ROUTE_TAGS.FILE}/list`,
  FILE_DOWNLOAD: `${API_ROUTE_TAGS.FILE}/download`,
  // AI endpoints
  UPLOAD_ENGAGEMENT_PDF: `${API_ROUTE_TAGS.FILE}/upload-engagement-pdf`,
  AI_EXTRACT_ENGAGEMENTS: `/ai/extract-engagements-from-pdf`,
  AI_ANALYZE_LINKAGE: `/ai/analyze-voting-engagement-linkage`,
  AI_BATCH_LINKAGE: `/ai/analyze-batch-linkage`,
  AI_GET_JOB_STATUS: `/ai/get-job-status`,
  AI_GET_JOBS: `/ai/get-jobs`,
  AI_PREPARE_PORTFOLIO_NEWS: `/ai/prepare-portfolio-news`,
  AI_MARK_JOB_FAILED: `/ai/mark-job-failed`,
  AI_PREFILL_ENGAGEMENT: `/ai/prefill-engagement`,
  AI_PREFILL_INTERACTION: `/ai/prefill-interaction`,
  AI_ASSESS_ENGAGEMENTS_BATCH: `/ai/assess-engagements-batch`,
  AI_GET_ENGAGEMENT_ASSESSMENT: `/ai/get-engagement-assessment`,
  AI_ASSESS_ENGAGEMENT: `/ai/assess-engagement`,
  AI_PERSIST_ASSESSMENTS: `/ai/persist-assessments`,
  AI_ASSESS_ENGAGEMENT_V2: `/ai/assess-engagement-v2`,
  AI_ASSESS_ENGAGEMENTS_BATCH_V2: `/ai/assess-engagements-batch-v2`,
  AI_GET_ENGAGEMENT_ASSESSMENT_V2: `/ai/get-engagement-assessment-v2`,
  // Linkage dashboard endpoints
  GET_LINKAGE_THEME_DYNAMICS: `${API_ROUTE_TAGS.DATA}/get-linkage-theme-dynamics`,
  GET_LINKAGE_MATERIAL_ESCALATION: `${API_ROUTE_TAGS.DATA}/get-linkage-material-escalation`,
  GET_LINKAGE_COLLABORATION_TENSION: `${API_ROUTE_TAGS.DATA}/get-linkage-collaboration-tension`,
  GET_LINKAGE_RECORDS: `${API_ROUTE_TAGS.DATA}/get-linkage-records`,
  GET_LINKAGE_FILTER_OPTIONS: `${API_ROUTE_TAGS.DATA}/get-linkage-filter-options`,
};

export const LOCAL_STORAGE_TOKEN_KEY = "token";
